import React from 'react';
import isEmpty from 'lodash/isEmpty';

import { setLanguage } from './translations';

import PageRoutes from './pages/PageRoutes';

export default class ConsumerOneApp extends React.Component {
    constructor(props) {
        super(props);

        // creates a store w/ Redux logging defaulted in development environment
        // also adds `redux-thunk` middleware by default for async actions
        // props.history.replace(props.request.path);

        if (!isEmpty(props)) {
            // eslint-disable-next-line react/prop-types
            setLanguage(props.env.localeInfo.locale);
        }
    }

    render() {
        return <PageRoutes {...this.props} />;
    }
}
